import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserCashBack from './user-cash-back';
import UserCashBackDetail from './user-cash-back-detail';
import UserCashBackUpdate from './user-cash-back-update';
import UserCashBackDeleteDialog from './user-cash-back-delete-dialog';

const UserCashBackRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserCashBack />} />
    <Route path="new" element={<UserCashBackUpdate />} />
    <Route path=":id">
      <Route index element={<UserCashBackDetail />} />
      <Route path="edit" element={<UserCashBackUpdate />} />
      <Route path="delete" element={<UserCashBackDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserCashBackRoutes;
